import React, { useState, useRef, useEffect } from "react";
import "./Login.css";
import { Link, redirect, useNavigate, useNavigation } from "react-router-dom";
import { Eye, EyeOff, LockKeyhole, Mail, User, UserPen } from "lucide-react";
import { Flex, Spinner } from "@chakra-ui/react";
import NavBar from "../../../../navbar/Navbar";
import { useDispatch } from "react-redux";
import { singUp } from "../../../../redux/reduxApi/SingIn&SingUp/SingUpApi";
import toast from "react-hot-toast";
import logo from "../../../../../assets/image/logo.png";
import { singIn } from "../../../../redux/reduxApi/SingIn&SingUp/SinginApi";
import { FcGoogle } from "react-icons/fc";
// import {
//     signInWithGoogle,
//     storeDataAfterGoogelSingin,
// } from "../../../../redux/reduxApi/SingIn&SingUp/SingInWithGoogelApi";
import axios from "axios";
import { baseUrl } from "../../../../../boot";
import { customerLogin, customerRegister } from "../../../../redux/api/customer/customerAuth";

const Signin = () => {
    const [isRightPanelActive, setIsRightPanelActive] = useState(false);
    const [formData, setFormData] = useState({
        firstName: "",
        email: "",
        password: "",
    });
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const dispacth = useDispatch();
    const mobileRef = useRef(null);
    //  const [lastScrollY, setLastScrollY] = useState(0);
    //  const scrollRef = useRef(null);
    const [ismobile, setIsmobile] = useState(false);
    const desktopRef = useRef(null);
    const [isSignupOpen, setIsSignupOpen] = useState(false);
    // function to check screen size and show hide contente
    const handleResize = () => {
        if (window.innerWidth < 600) {
            desktopRef.current.classList.add("d-none");
            mobileRef.current.classList.remove("d-none");
            setIsmobile(true);
        } else {
            desktopRef.current.classList.remove("d-none");
            mobileRef.current.classList.add("d-none");
            setIsmobile(false);
        }
    };
    useEffect(() => {
        handleResize(); // Check the screen width on the first load
        window.addEventListener("resize", handleResize); // Listen for screen size changes

        return () => {
            window.removeEventListener("resize", handleResize); // Clean up event listener
        };
    }, []);
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSignin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const res = await dispacth(customerLogin(formData));

            if (res.payload.data.success) {

                toast.success("Login Successfully")
                window.dispatchEvent(new Event("authChange"));
                const redirectPath = localStorage.getItem("redirect");
                if (redirectPath) {
                    localStorage.removeItem("redirect");
                    navigate(redirectPath);
                } else {
                    navigate("/");
                }
            } else {
                toast.success(res.payload.data.msg)
            }
        } catch (err) {
            setIsLoading(false);
            toast.error(err?.response?.data?.msg || err?.response?.data?.error || err.message || "Login Failed")
        } finally {
            setIsLoading(false)
        }
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        customerRegister(formData).then((response) => {
            if (response.data.success) {
                toast.success(response?.data?.message);
                navigate(`/singup-otp/${formData.email}`);
            } else {
                setIsLoading(false);
                toast.error(response?.data?.message);
            }
        }).catch((err) => {
            toast.error(err?.response?.data?.message || err?.message || "Sign Up failed")
        }).finally(() => {
            setIsLoading(false)
        })
        // try {
        //   const response = await dispacth(singUp(formData));
        //   console.log("Signup Response:", response.payload.data);
        //   if (response.payload.data.success) {
        //     setIsLoading(false);
        //     toast.success(response.payload.data.message);
        //     navigate(`/singup-otp/${formData.email}`);
        //   } else {
        //     setIsLoading(false);
        //     toast.error(response.payload.data.message);
        //   }
        // } catch (error) {
        //   console.log(error);
        //   setIsLoading(false);
        //   toast.error("Signup failed");
        // }
    };

    // const handleGoogleSignIn = async () => {
    //     try {
    //         const { email, firstName, lastName, sub, picture, isVerified } =
    //             await signInWithGoogle();
    //         const data = {
    //             sub: sub,
    //             email: email,
    //             firstName: firstName,
    //             lastName: lastName,
    //             picture: picture,
    //             isVerified: true,
    //         };
    //         let response;
    //         if (email) {
    //             setIsLoading(true);
    //             response = await dispacth(storeDataAfterGoogelSingin(data));
    //         }

    //         if (response.payload.success) {
    //             setIsLoading(false);

    //             toast.success("Login Successfully ");
    //             dispacth({ type: "CLOSE_AUTH_MODAL" });
    //             window.dispatchEvent(new Event("authChange"));
    //             const redirectPath = localStorage.getItem("redirect");
    //             redirectPath ? navigate(redirectPath) : navigate("/");
    //         }
    //     } catch (error) {
    //         setIsLoading(false);
    //         toast.error("Google Signin Failed");
    //     }
    // };

    return (
        <>
            {/* {isLoading && (
                <div className="spinner-overlay">
                    <Spinner size="xl" color="orange.500" />
                </div>
            )} */}
            <div  ref={desktopRef} style={{ maxHeight: ismobile ? "50vh" : "80vh" }}>
                <div className="outer">
                    {" "}
                    <NavBar />
                    <div
                        className={`containerr ${isRightPanelActive ? "right-panel-active" : ""
                            }`}
                        style={{ marginTop: "180px" }}
                    >
                        {/* Sign In Container */}
                        <div
                            className={`Login-container sign-in-container ${isRightPanelActive ? "inactive" : "active"
                                }`}
                        >
                            <form className="formClass" onSubmit={handleSignin}>
                                <p className="mb-4 text-4xl font-bold text-blue-900">Login</p>
                                <div
                                    className="d-flex rounded-[30px] bg-[#EEEEEE] text-center border border-blue-900"
                                    style={{
                                        background: "#EEEEEE",
                                        width: "99%",
                                        height: "47px",
                                    }}
                                >
                                    <span className="flex items-center ml-2  text-gray-500 ">
                                        <Mail className="size-6" />
                                    </span>

                                    <input
                                        type="text"
                                        name="email"
                                        placeholder="Username (Email)"
                                        required
                                        onChange={handleChange}

                                        className="focus:outline-none border-0 px-2 py-2 border-blue-900"
                                    />
                                </div>
                                <div
                                    className="d-flex mt-3   rounded-[30px] bg-[#EEEEEE] text-center border border-blue-900"
                                    style={{
                                        background: "#EEEEEE",
                                        width: "99%",
                                        height: "47px",
                                    }}
                                >
                                    <span className="flex items-center ml-2  text-gray-500 ">
                                        <LockKeyhole className="size-5" />
                                    </span>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        onChange={handleChange}
                                        placeholder="Password"
                                        maxLength={8}
                                        required
                                        className=" border-0 shadow-none px-2 py-2 text-gray-600 focus:outline-none "
                                    />
                                    <span
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="d-flex mx-2"
                                        style={{ alignItems: "center", cursor: "pointer" }}
                                    >
                                        {showPassword ? (
                                            <Eye className="cursor-pointer" />
                                        ) : (
                                            <EyeOff className="cursor-pointer" />
                                        )}
                                    </span>

                                </div>
                                <span className="text-gray-600 text-xs w-full ml-8  text-start">Maximum 8 characters allowed</span>

                                <Link to="/forgot-password">
                                    <p
                                        className="mt-2 text-lg font-semibold"
                                        style={{
                                            cursor: "pointer",
                                            color: "#034C8C",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Forgot Password ?
                                    </p>
                                </Link>
                                <button
                                    type="submit"
                                    className="flex  items-center justify-center bg-[#f97316]  text-white   gap-2 signinn-button py-2"
                                    style={{ width: "100%" }}
                                >
                                    {isLoading ? <> <Flex justifyContent={'center'} alignItems={'center'} gap={'2'} ><Spinner size={'sm'} /> <span>Loading..</span></Flex> </> : "Sign In"}

                                </button>

                                <button
                                    // onClick={() => handleGoogleSignIn()}
                                    type="button"
                                    className="flex mt-3 items-center  justify-center  border-1 border-orange-500  py-[5px] gap-2 rounded-full w-full "
                                >
                                    <FcGoogle size={24} />
                                    <span className="text-base font-semibold text-gray-800">
                                        {" "}
                                        Sign in with Google
                                    </span>
                                </button>
                            </form>
                        </div>

                        {/* Sign Up Container */}
                        <div
                            className={`Login-container sign-up-container   ${isRightPanelActive ? "active" : "inactive"
                                }`}
                        >
                            <form className="formClass " onSubmit={handleSignup}>
                                <p className="mb-4 text-4xl font-bold text-blue-900">
                                    Create Account
                                </p>
                                <div
                                    className="d-flex rounded-[30px] bg-[#EEEEEE] text-center border border-blue-900 mb-3"
                                    style={{
                                        background: "#EEEEEE",
                                        width: "99%",
                                        height: "47px",
                                    }}
                                >
                                    <span className="flex items-center ml-2  text-gray-500 ">
                                        <UserPen className="size-6" />
                                    </span>
                                    <input
                                        type="text"
                                        name="firstName"
                                        placeholder="Name"
                                        required
                                        onChange={handleChange}
                                        className="focus:outline-none border-0 px-2 py-2 border-blue-900"
                                    />
                                </div>
                                <div
                                    className="d-flex rounded-[30px] bg-[#EEEEEE] text-center border border-blue-900"
                                    style={{
                                        background: "#EEEEEE",
                                        width: "99%",
                                        height: "47px",
                                    }}
                                >
                                    <span className="flex items-center ml-2  text-gray-500 ">
                                        <Mail className="size-6" />
                                    </span>

                                    <input
                                        type="text"
                                        name="email"
                                        placeholder="Email"
                                        required
                                        onChange={handleChange}
                                        className="focus:outline-none border-0 px-2 py-2 border-blue-900"
                                    />
                                </div>
                                <div
                                    className="d-flex mt-3   rounded-[30px] bg-[#EEEEEE] text-center border border-blue-900"
                                    style={{
                                        background: "#EEEEEE",
                                        width: "99%",
                                        height: "47px",
                                    }}
                                >
                                    <span className="flex items-center ml-2  text-gray-500 ">
                                        <LockKeyhole className="size-5" />
                                    </span>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        onChange={handleChange}
                                        placeholder="Password"
                                        maxLength={8}
                                        required
                                        className=" border-0 shadow-none px-2 py-2 text-gray-600 focus:outline-none "
                                    />
                                    <span
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="d-flex mx-2"
                                        style={{ alignItems: "center", cursor: "pointer" }}
                                    >
                                        {showPassword ? (
                                            <Eye className="cursor-pointer" />
                                        ) : (
                                            <EyeOff className="cursor-pointer" />
                                        )}
                                    </span>
                                </div>
                                <span className="text-gray-600 text-xs w-full ml-8  text-start">Maximum 8 characters allowed</span>
                                <button disabled={isLoading}
                                    type="submit"
                                    className="signup-button mt-4 text-blue-900 w-100"
                                >
                                    {isLoading ? <> <Flex justifyContent={'center'} alignItems={'center'} gap={'2'} ><Spinner size={'sm'} /> <span>Loading..</span></Flex> </> : "Sign Up"}
                                </button>
                            </form>
                        </div>

                        {/* Overlay for Switching Forms */}
                        <div className="    -container">
                            <div className="overlay">
                                <div className="overlay-panel overlay-left">
                                    <img
                                        src={logo}
                                        alt="Vancouver Logo"
                                        style={{ width: "250px", height: "90px" }}
                                    />
                                    <h1>Welcome Back!</h1>
                                    <p className="singinP">
                                        To keep connected with us please login with your personal
                                        info
                                    </p>
                                    <button
                                        className="signin-button"
                                        onClick={() => setIsRightPanelActive(false)}
                                    >
                                        Sign In
                                    </button>
                                </div>
                                <div className="overlay-panel overlay-right">
                                    <img
                                        src={logo}
                                        alt="Mobex Logo"
                                        style={{ width: "250px", height: "90px" }}
                                        className="mb-2"
                                    />
                                    <h1>Register!</h1>

                                    <p className="singinP">
                                        Enter your personal details and start your journey with us
                                    </p>
                                    <button
                                        className="signup-button"
                                        onClick={() => setIsRightPanelActive(true)}
                                    >
                                        Sign Up
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                ref={mobileRef}
                style={{ maxHeight: "100vh", backgroundColor: "white" }}
                className="d-none"
            >
                {/* Sign In Container */}
                {isSignupOpen ? (
                    <div className={`Login-container sign-in-container  `}>
                        <form className="formClass " onSubmit={handleSignin}>
                            <div className="flex items-center justify-center flex-col rounded-2xl border-gray-100 w-full  p-5 shadow">
                                <img
                                    src={logo}
                                    alt="Vancouver Logo"
                                    style={{ width: "300px", height: "90px" }}
                                />
                             
                                <p className="mb-4 text-4xl text-blue-900 font-bold">Sign in</p>

                                <input
                                    type="text"
                                    name="email"
                                    placeholder="Email"
                                    required
                                    onChange={handleChange}
                                    className="focus:outline-none border border-gray-700 rounded my-1 sm:h-[40px] w-full py-2 px-3"
                                />
                                <div
                                    className="d-flex rounded-3 text-center rounded my-1 border border-gray-700"
                                    style={{ width: "99%", height: "40px" }}
                                >
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        onChange={handleChange}
                                        placeholder="Password"
                                        required
                                        className="form-control border-0 shadow-none px-3 py-2 text-gray-600 focus:outline-none "
                                    />
                                    <span
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="d-flex mx-2"
                                        style={{ alignItems: "center", cursor: "pointer" }}
                                    >
                                        {showPassword ? (
                                            <Eye className="cursor-pointer" />
                                        ) : (
                                            <EyeOff className="cursor-pointer" />
                                        )}
                                    </span>
                                </div>
                                <Link to="/forgot-password">
                                    <span style={{ cursor: "pointer", color: "#034C8C" }}>
                                        Forgot Password
                                    </span>
                                </Link>
                                <button
                                    type="submit"
                                    className="flex mt-3 items-center  justify-center gap-2 signinn-button mb-2"
                                    style={{ width: "73%" }}
                                >
                                    {isLoading ? <> <Flex justifyContent={'center'} alignItems={'center'} gap={'2'} ><Spinner size={'sm'} /> <span>Loading..</span></Flex> </> : "Sign In"}

                                </button>
                                <button
                                    // onClick={() => handleGoogleSignIn()}
                                    type="button"
                                    className="flex mb-2 items-center justify-center gap-2 google-button"
                                >
                                    <FcGoogle size={24} />
                                    Sign in with Google
                                </button>

                                <span style={{ cursor: "pointer", color: "#034C8C" }}>
                                    Don't have an account ?
                                    <span
                                        onClick={() => setIsSignupOpen(false)}
                                        className="text-orange-500 "
                                    >
                                        {" "}
                                        Sign Up
                                    </span>
                                </span>
                            </div>

                            {/* <button type="button" className="flex mt-3 items-center justify-center gap-2 signinn-button " style={{ width: '75%', margin: 'auto' }} onClick={() => { setIsSignupOpen(false) }}>
                            Sign Up
                           </button> */}
                        </form>
                    </div>
                ) : (
                    <div className={` sign-up-container  `}>
                        <form className="formClass" onSubmit={handleSignup}>
                            <div className="flex items-center justify-center flex-col rounded-2xl border-gray-100 w-full  p-5 shadow">
                            <img
                                    src={logo}
                                    alt="Mobex Logo"
                                    style={{ width: "200px", height: "80px" }}
                                />
                                {/* <button
                                    onClick={() => handleGoogleSignIn()}
                                    type="button"
                                    className="flex mt-3 items-center justify-center gap-2 google-button"
                                >
                                    <FcGoogle size={24} />
                                    Sign in with Google
                                </button> */}

                                {/* <p className=" text-xl font-bold my-4"/>Sign up with email</p> */}
                                <p className="mb-4 text-4xl font-bold text-blue-900">
                                    Create Account
                                </p>


                                <input
                                    type="text"
                                    name="firstName"
                                    placeholder="Name"
                                    required
                                    onChange={handleChange}
                                    className="focus:outline-none border border-gray-700 rounded my-1 sm:h-[40px] w-full py-2 px-3"
                                />

                                <input
                                    type="text"
                                    name="email"
                                    placeholder="Email"
                                    required
                                    onChange={handleChange}
                                    className="focus:outline-none border border-gray-700 rounded my-1 sm:h-[40px] w-full py-2 px-3"
                                />
                                <div
                                    className="d-flex rounded-3 text-center rounded my-1 border border-gray-700"
                                    style={{ width: "99%", height: "40px" }}
                                >
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        onChange={handleChange}
                                        placeholder="Password"
                                        required
                                        className="form-control border-0 shadow-none px-3 py-2 text-gray-600 focus:outline-none "
                                    />
                                    <span
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="d-flex mx-2"
                                        style={{ alignItems: "center", cursor: "pointer" }}
                                    >
                                        {showPassword ? (
                                            <Eye className="cursor-pointer" />
                                        ) : (
                                            <EyeOff className="cursor-pointer" />
                                        )}
                                    </span>
                                </div>
                                <button
                                    type="submit"
                                    className="flex mt-3 items-center justify-center gap-2 signinn-button mb-2"
                                    style={{ width: "73%" }}
                                >{isLoading ? <> <Flex justifyContent={'center'} alignItems={'center'} gap={'2'} ><Spinner size={'sm'} /> <span>Loading..</span></Flex> </> : "Sign Up"}

                                </button>
                                <span style={{ cursor: "pointer", color: "#034C8C" }}>
                                    Already have an account ?
                                    <span
                                        onClick={() => setIsSignupOpen(true)}
                                        className="text-orange-500 "
                                    >
                                        {" "}
                                        Sign in
                                    </span>
                                </span>
                            </div>

                            {/* <button type="button" className="create-button mt-3 w-100" style={{ width: '75%', margin: 'auto' }} onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setIsSignupOpen(true)
              }}>
                Sign in
              </button> */}
                        </form>
                    </div>
                )}
            </div>
        </>
    );
};

export default Signin;
